import React, { useReducer } from "react";
import axios from "axios";
import GithubContext from "./githubContext";
import GithubReducer from "./githubReducer";

import {
  SEARCH_USERS,
  SET_LOADING,
  CLEAR_USERS,
  GET_USER,
  GET_REPOS,
} from "../types";

let githubClientId;
let githubClientSecret;

if (process.env.NODE_ENV !== "production") {
  githubClientId = process.env.REACT_APP_GITHUB_CLIENT_ID;
  githubClientSecret = process.env.REACT_APP_GITHUB_CLIENT_SECRET;
} else {
  githubClientId = process.env.GITHUB_CLIENT_ID;
  githubClientSecret = process.env.GITHUB_CLIENT_SECRET;
}

const GithubState = (props) => {
  const initialState = {
    users: [],
    user: {},
    repos: [],
    loading: false,
    clicked: false,
  };

  const [state, dispatch] = useReducer(GithubReducer, initialState);

  //Search users
  const searchUsers = async (text, clicked) => {
    setLoading();
    try {
      const res = await axios.get(
        `https://api.github.com/search/users?q=${text}`,
        {
          params: {
            my_client_id: githubClientId,
            my_client_secret: githubClientSecret,
          },
        }
      );
      dispatch({
        type: SEARCH_USERS,
        payload: res.data.items,
        click: clicked,
      });
    } catch (err) {
      dispatch({ type: SEARCH_USERS, payload: [], click: true });
      console.error("Search failed:", err.message);
    }
  };

  //get user
  const getUser = async (username) => {
    setLoading();
    try {
      const res = await axios.get(
        `https://api.github.com/users/${username}`,
        {
          params: {
            client_id: githubClientId,
            client_secret: githubClientSecret,
          },
        }
      );
      dispatch({
        type: GET_USER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: GET_USER, payload: {} });
      console.error("Get user failed:", err.message);
    }
  };

  //get repos
  const getUserRepos = async (username) => {
    setLoading();
    try {
      const res = await axios.get(
        `https://api.github.com/users/${username}/repos`,
        {
          params: {
            client_id: githubClientId,
            client_secret: githubClientSecret,
            per_page: 30,
            sort: "stars",
            direction: "desc",
          },
        }
      );
      dispatch({
        type: GET_REPOS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: GET_REPOS, payload: [] });
      console.error("Get repos failed:", err.message);
    }
  };

  //clear users
  const clearUsers = () => dispatch({ type: CLEAR_USERS });

  //set loading

  const setLoading = () => dispatch({ type: SET_LOADING });

  return (
    <GithubContext.Provider
      value={{
        users: state.users,
        user: state.user,
        repos: state.repos,
        loading: state.loading,
        clicked: state.clicked,
        searchUsers,
        clearUsers,
        getUser,
        getUserRepos,
      }}
    >
      {props.children}
    </GithubContext.Provider>
  );
};

export default GithubState;
